import { jsx as r, jsxs as x } from "react/jsx-runtime";
import g from "focus-trap-react";
import "styled-components";
import { useThemeInMode as h } from "../../../../../context/theme/hooks.js";
import { I as b } from "../../../../../ActionButton-B77eJAd5.js";
import "react";
import "../../../../../styles/icons/icons.js";
import "../../../../layout/Stack/Stack.js";
import e from "../../../../layout/Box/Box.js";
import "../../../../../index-CZ8zjHGv.js";
import "../../../../layout/Center/Center.js";
import "../../../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../../../layout/Columns/ColumnsContext.js";
import "../../../../typography/Text/Text.js";
import T from "../../../../../hooks/useBreakpoint.js";
import "../../../../../context/Text.js";
import "../../../../../context/Typography.js";
import "../../../../../hooks/link/index.js";
import "@material/material-color-utilities";
import "../../../Logo/consts.js";
import "react-select";
import "react-select/async";
import "../../../../controls/Toggle/CustomCheckbox.js";
import A from "./components/StandardContentLayout/StandardContentLayout.js";
import { MAX_WIDTH_MAP as I } from "./consts.js";
import { isStandardContent as M } from "./utils.js";
function V({
  children: i,
  inContainer: o,
  onCloseClick: m,
  padding: a,
  maxWidth: p,
  fullscreenOnMobile: s,
  overflowY: n,
  noTopImageContainer: d,
  allowOutsideClick: l
}) {
  const c = h(), t = M(i), u = s && !o ? {
    height: ["100%", "unset"],
    borderRadius: ["none", "12"]
  } : { height: "unset", borderRadius: "12" }, { isMobileOnly: f } = T();
  return /* @__PURE__ */ r(
    g,
    {
      active: !o && !f,
      focusTrapOptions: {
        allowOutsideClick: l
      },
      children: /* @__PURE__ */ x(
        e,
        {
          position: o ? "absolute" : "fixed",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          margin: "auto",
          paddingY: t ? "xxlarge" : a,
          paddingX: t ? "xxlarge" : ["xlarge", a],
          maxWidth: t ? "560px" : I[p],
          width: "100%",
          maxHeight: ["100%", "90%"],
          overflowY: n,
          backgroundColor: c.foreground,
          ...u,
          dataTest: "Modal",
          UNSAFE_role: "dialog",
          "aria-modal": !o,
          children: [
            m && /* @__PURE__ */ r(e, { position: "absolute", top: "12px", right: "12px", children: /* @__PURE__ */ r(
              b,
              {
                iconName: "cross",
                accessibilityLabel: "Close modal",
                onClick: m,
                size: "small",
                tone: "neutral"
              }
            ) }),
            t ? /* @__PURE__ */ r(A, { noTopImageContainer: d, children: i }) : i
          ]
        }
      )
    }
  );
}
export {
  V as default
};
